import { render } from "./GridRow.vue?vue&type=template&id=1020e4d8&scoped=true&ts=true"
import script from "./GridRow.vue?vue&type=script&lang=ts"
export * from "./GridRow.vue?vue&type=script&lang=ts"

import "./GridRow.vue?vue&type=style&index=0&id=1020e4d8&lang=scss&scoped=true"

import exportComponent from "C:\\TeamCityBuildAgent\\work\\623dcfb411009e26\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1020e4d8"]])

export default __exports__